import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const EmbeddedBucketLightSchema = z.object({
  id: z.number().int().nullable().openapi({ description: 'Bucket ID', example: 1 }),
  title: z.string().nullable().openapi({ description: 'Bucket title', example: 'Timely/app' }),
  icon_url: z
    .string()
    .nullable()
    .openapi({ description: 'Bucket icon URL', example: 'https://...' }),
});

/**
 * Create Buckets via minimal definitions, used for Memories atm
 * @todo Revisit when we have a proper Bucket model in Zod
 */
export const CreateBucketLightSchema = z.object({
  uri: z
    .string()
    .url()
    .openapi({ description: 'Bucket URI', example: 'https://api.github.com/repos/Timely/app' }),
  title: z
    .string()
    .optional()
    .nullable()
    .openapi({ description: 'Bucket title', example: 'Timely/app' }),
  icon_url: z
    .string()
    .nullable()
    .optional()
    .openapi({ description: 'Bucket icon URL', example: 'https://...' }),
  type: z
    .string()
    .optional()
    .nullable()
    .openapi({ description: '@todo consolidate with Provider types in db', example: 'repository' }),
});
